import React, { useMemo } from "react";
import Fade from "react-reveal/Fade";
import { useGetProductListQuery } from "../../../utils/api/product/product.api";
import { usePagination } from "../../../utils/hooks";
import { Product } from "../../../utils/api/product/product.type";
import BestSellerCatalogGrid from "../../HomePage/BestSellerCatalogGrid";

const SIMILAR_LIMIT = 12;

function ProductSimilary({ product }: { product: Product }) {
  const { limit } = usePagination(13);
  const { data, isLoading } = useGetProductListQuery({
    categorie: product?.categorie?.slug,
    sous_categorie: product?.sous_categorie?.slug || "",
    limit,
  });

  const similarProducts = useMemo(() => {
    if (!data?.results?.length) return [];
    return data.results
      .filter((el) => el?.id !== product?.id)
      .slice(0, SIMILAR_LIMIT);
  }, [data?.results, product?.id]);

  return (
    <section
      className="best-sellers-section best-sellers-section--nos-produits px-lg-3 mb-5"
      aria-labelledby="produits-similaires-heading"
    >
      <div className="best-sellers-section-container">
        <Fade bottom>
          <header className="best-sellers-section-header">
            <h2
              id="produits-similaires-heading"
              className="best-sellers-section-title text-center"
            >
              PRODUITS SIMILAIRES
            </h2>
          </header>
        </Fade>
        {isLoading ? (
          <BestSellerCatalogGrid
            products={[]}
            isLoading
            skeletonCount={SIMILAR_LIMIT}
          />
        ) : similarProducts.length > 0 ? (
          <BestSellerCatalogGrid products={similarProducts} isLoading={false} />
        ) : (
          <p className="best-sellers-section-empty text-center mb-0">
            Aucun produit similaire disponible pour le moment.
          </p>
        )}
      </div>
    </section>
  );
}

export default ProductSimilary;
